/* global window */
import React, { useEffect, useRef } from 'react';
import { string, func } from 'prop-types';
import '../styles/ZoomableImageWithLens.css';
import protectCopyRight from '../helpers/protectCopyRight';


const ZoomableImageWithLens = ({ imageAlt, imageUrl, onClick }) => {
    const containerRef = useRef(null);
    const imageRef = useRef(null);
    const lensRef = useRef(null);
    const resultRef = useRef(null);

    /** Event Handlers */
    const handleZoomPreview = (e) => {
        if (
            !containerRef.current
            || !imageRef.current
            || !lensRef.current
            || !resultRef.current
        ) {
            return;
        }

        const container = containerRef.current;
        const image = imageRef.current;
        const lens = lensRef.current;
        const result = resultRef.current;
        if (!container.contains(e.target)) {
            lens.style.display = 'none';
            result.style.display = 'none';
            return;
        }

        lens.style.display = 'block';
        result.style.display = 'block';
        result.style.height = `${image.height}px`;
        result.style.width = `${image.width}px`;

        // Calculate scale.
        const scaleX = result.offsetWidth / lens.offsetWidth;
        const scaleY = result.offsetHeight / lens.offsetHeight;

        // Resize background image of result DIV.
        result.style.backgroundSize = `${image.width * scaleX}px ${image.height * scaleY}px`;

        // Calculate the cursor's x and y coordinates, relative to the image.
        const imageRect = image.getBoundingClientRect();
        let x = e.pageX - imageRect.left;
        let y = e.pageY - imageRect.top;
        // Offset for page scrolling
        x = x - window.scrollX;
        y = y - window.scrollY;

        // Calculate lens position.
        let lensX = x - lens.offsetWidth / 2;
        let lensY = y - lens.offsetHeight / 2;
        if (lensX > image.width - lens.offsetWidth) {
            lensX = image.width - lens.offsetWidth;
        }
        if (lensX < 0) {
            lensX = 0;
        }
        if (lensY > image.height - lens.offsetHeight) {
            lensY = image.height - lens.offsetHeight;
        }
        if (lensY < 0) {
            lensY = 0;
        }
        lens.style.left = `${lensX + (container.clientWidth - image.clientWidth) / 2}px`;
        lens.style.top = `${lensY + (container.clientHeight - image.clientHeight) / 2}px`;
        result.style.backgroundPosition = `-${lensX * scaleX}px -${lensY * scaleY}px`;
    };

    // Mount event handlers.
    useEffect(() => {
        window.addEventListener('mousemove', handleZoomPreview);
        window.addEventListener('touchmove', handleZoomPreview);
    }, []);

    return <div
        className={'zoomable-image-with-lens--container'}
        ref={containerRef}
    >
        <button
            style={{
                all: 'unset',
                display: 'block',
            }}
            onClick={onClick}
            onContextMenu={protectCopyRight}>
            <div
                className={'zoomable-image-with-lens--lens'}
                ref={lensRef}>
            </div>
        </button>
        <button
            style={{
                all: 'unset',
                display: 'block',
            }}
            onClick={onClick}>
            <img
                alt={imageAlt}
                ref={imageRef}
                src={imageUrl}
            />
        </button>
        <div
            className={'zoomable-image-with-lens--result'}
            ref={resultRef}
            style={{
                backgroundImage: `url('${imageUrl}')`,
            }}>
        </div>
    </div>;
};

ZoomableImageWithLens.defaultProps = {
    imageAlt: '',
    onClick: () => {},
};

ZoomableImageWithLens.propTypes = {
    imageUrl: string.isRequired,
    imageAlt: string,
    onClick: func,
};

export default ZoomableImageWithLens;